import React, { useState, useEffect } from "react";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';

const TermsOfUse = () => {
    usePageTitle('Terms of Use - Wefayo');

    return (
        <CommunityLayout currentPage={"terms"} onCommunitiesLoaded={() => { }} >
            <article className="flex flex-col overflow-hidden text-sm bg-primary-white rounded-md">
                <header class="flex flex-col ">
                    <h1 class="text-lg px-8 pt-3 font-bold tracking-tight text-zinc-800 sm:text-lg">
                        Terms and Conditions
                    </h1>
                </header>

                <div class="flex flex-col mt-5 px-8 pt-1 pb-5 prose max-w-none gap-y-4 "  >

                    
                    <div>
                        <h4 className="mt-0">1. Welcome</h4>
                        <p className="mb-0">
                            Wefayo is a free platform built to help people find community, support, and resources. These
                            Terms and Conditions (“Terms”) govern your use of the Service and protect both you and
                            Wefayo. Please read them carefully.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">2. Agreement to These Terms</h4>
                        <p className="mb-0">
                            By accessing or using wefayo.com or any related services (the “Service”), you agree to these
                            Terms and Conditions. If you do not agree, do not use the Service.
                            <br />
                            Wefayo LLC (“Wefayo,” “we,” “us,” or “our”) may update these Terms at any time. Continued
                            use of the Service after changes are posted means you accept the updated Terms.
                            These Terms apply to both individual users and organizations that register for the Service. If you
                            register on behalf of an organization, you confirm that you are authorized to accept these Terms
                            for that organization.
                            <br />
                            These Terms, together with our Privacy Policy, constitute the entire agreement between you
                            and Wefayo regarding your use of the Service and supersede any prior agreements or
                            representations. In the event of any conflict between these Terms and the Privacy Policy, these
                            Terms govern.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">3. Eligibility</h4>
                        <p className="mb-0">
                            You must be at least 15 years of age to use the Service. If you are under 18, you represent that
                            you have your parent's or legal guardian's permission to use the Service and that they have
                            reviewed and agreed to these Terms on your behalf.
                            <br />
                            By using the Service, you represent and warrant that you meet these eligibility requirements.
                            Wefayo reserves the right to terminate accounts of users who do not meet these requirements.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">4. Your Responsibility for Content</h4>
                        <p className="mb-0">
                            You are solely responsible for everything you post, upload, share, or transmit through the
                            Service.
                            <br />
                            We do not control user content and do not guarantee that it is accurate, complete, current, or
                            reliable. We are not liable for errors, omissions, or harm arising from content posted by users.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">5. General Disclaimers</h4>
                        <h6 className="mt-0 mb-0 font-semibold">5.1 No Professional Advice</h6>
                        <p className="mb-0 mt-0">
                            Nothing on the Service is intended to provide legal, medical, psychological, therapeutic,
                            financial, or other professional advice. This applies to all content on the Service, including
                            responses from community members, volunteer contributors, advocates, students,
                            professionals, and any AI-powered features.
                            <br />
                            Always consult a qualified professional before making any important decision, including those
                            affecting your health, legal rights, finances, or well-being.
                        </p>
                        <h6 className="mt-0 mb-0 font-semibold">5.2 No Warranty</h6>
                        <p className="mb-0 mt-0">
                            Wefayo does not verify the credentials, licenses, or qualifications of contributors, third-party
                            event organizers, employers, sellers, or any other third party appearing on or linked from the
                            Service, unless expressly stated in writing for a specific program.
                            <br />
                            The presence of any contributor, listing, link, or individual on the Service does not constitute an
                            endorsement by Wefayo. All content from contributors and third parties is informational only.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">6. Community and Volunteer Contributors</h4>
                        <p className="mb-0">
                            Some parts of the Service may include volunteer contributors, community moderators,
                            advocates, students, professionals, or other individuals who participate on a voluntary basis.
                            <br />
                            Unless expressly stated in writing by Wefayo, these individuals are not employees, agents, or
                            representatives of Wefayo. Responses from contributors are informational only and do not
                            create a professional-client, attorney-client, therapist-client, or similar relationship. Student
                            contributors are not licensed professionals, and their responses do not constitute licensed
                            professional advice.
                            <br />
                            Wefayo is not responsible for any action taken, or harm resulting from any action taken, in
                            reliance on responses provided by contributors or community members. For general disclaimers
                            regarding endorsement and professional advice, see Section 5.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">7. AI-Powered Services</h4>
                        <p className="mb-0">
                            Wefayo offers optional AI-powered services, clearly labeled as AI within the Service. These
                            features are provided by a third-party AI provider, which processes what you enter in order to
                            generate responses.
                            <br />
                            AI outputs are for informational and supportive purposes only, may be inaccurate or incomplete,
                            and are subject to the disclaimers in Section 5. They do not constitute professional advice. You
                            use these features at your own risk.
                            <br />
                            For information on how Wefayo handles data generated through AI-powered services, including
                            conversation history and third-party AI provider interactions, please review our Privacy Policy.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">8. Assistive and Communication Tools</h4>
                        <p className="mb-0">
                            Wefayo offers assistive and communication tools designed to support users with a range of
                            preferences and needs. These tools run on Wefayo and do not send your content to third-party
                            AI providers.
                            <br />
                            Some tools offer optional settings that certain users may find helpful. These tools and settings
                            are general aids offered as options only. They are not medical devices, treatment, or therapy.
                            <br />
                            Wefayo makes no claim that any tool or setting will help, improve, or address any condition.
                            Every person and condition is different, and results vary. Use of these tools is at your own
                            discretion and subject to the general disclaimers in Section 5.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">9. Blue Envelope Program</h4>
                        <p className="mb-0">
                            The Wefayo Blue Envelope Program is a voluntary communication support initiative. It provides
                            free, optional, printable materials intended to aid communication during traffic stops and similar
                            high-stress interactions with law enforcement and first responders.
                            <br />
                            The Blue Envelope Program is informational in nature. It is not an official government document,
                            a legal document, a license, or a form of identification. It does not change any person’s legal
                            rights or obligations, does not replace standard procedures, and does not limit the discretion or
                            authority of any law enforcement officer or first responder.
                            <br />
                            Participation is voluntary, and users choose whether and when to use or present the materials.
                            Wefayo does not train, direct, or coordinate with law enforcement or first responders, and does
                            not guarantee how any individual or agency will respond during any interaction.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">10. Third-Party Listings, Links, and Opportunities</h4>
                        <p className="mb-0">
                            Wefayo may display listings, links, and information provided by third parties, including events
                            and activities, job and volunteer opportunities, products and shops from disabled entrepreneurs,
                            and profiles of notable individuals. These listings are provided for convenience and
                            informational purposes only.
                            <br />
                            Any interaction, application, transaction, or communication you have with a third party is solely
                            between you and that third party. If you apply to a posting, your information is sent directly to the
                            poster, not to Wefayo. If you purchase from a linked shop, the transaction is solely with that
                            seller. Wefayo is not a party to and is not responsible for any such interaction, and you engage
                            at your own risk.
                            <br />
                            For Wefayo's general policy on endorsement and verification of third parties, see Section 5.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">11. Informational Communities and Support Services</h4>
                        <p className="mb-0">
                            Wefayo offers various communities, forums, and support services covering topics such as
                            advocacy, education, health, and disability. All such services are intended to provide general
                            information, peer support, and referral guidance only.
                            <br />
                            They are not a substitute for emergency services, mandatory reporting requirements, legal
                            counsel, medical care, mental health care, or other licensed professional services.
                            <br />
                            If anyone may be in immediate danger or an emergency is involved, contact local emergency
                            services right away.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">12. Community Rules</h4>
                        <p className="mb-0">
                            You agree not to post or engage in unlawful, threatening, abusive, harassing, defamatory,
                            obscene, hateful, discriminatory, or otherwise harmful conduct.
                            <br />You may not:
                            <ul className="list-disc pl-5 mt-0">
                                <li className="mb-0 mt-0"> Post personal information about others without their consent</li>
                                <li className="mb-0 mt-0"> Infringe intellectual property rights</li>
                                <li className="mb-0 mt-0"> Impersonate others or create multiple accounts</li>
                                <li className="mb-0 mt-0"> Spam or promote illegal activity</li>
                                <li className="mb-0 mt-0"> Disrupt the community or interfere with the Service</li>
                            </ul>
                            You may not post content you do not have the right to share under any law or under any
                            contractual or fiduciary obligation, such as a nondisclosure agreement.
                            <br />
                            You may not post unsolicited advertising, promotional materials, junk mail, chain letters,
                            pyramid schemes, or other solicitations.
                            Additional community rules:
                            <ul className="list-disc pl-5 mt-0">
                                <li className="mb-0 mt-0">One account per person. Creating multiple or alias accounts is not permitted. If a second
                                    account is found while an original account is banned, both accounts may be permanently
                                    banned and the person may be barred from re-registering.</li>
                                <li className="mb-0 mt-0">No double-posting or cross-posting the same message across multiple forums, and no
                                    sending the same message to many members by private message or email.</li>
                                <li className="mb-0 mt-0"> No posting intended only to increase views, clicks, or post counts.</li>
                                <li className="mb-0 mt-0">Moderators may determine, in their judgment, whether content is appropriate.</li>
                            </ul>
                            Violations may result in warnings, content removal, suspension, or permanent ban at our sole
                            discretion. To report a violation, email support@wefayo.com with the subject line “Posting Rules
                            Violation.”
                            <br />
                            To report content that you believe violates these Terms, email support@wefayo.com with the
                            subject line “Content Violation,” and identify the content and where it appears. Wefayo cannot
                            guarantee that any particular action will be taken in response to a report.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">13. License to Your Content</h4>
                        <p className="mb-0">
                            By posting content, you grant Wefayo a non-exclusive, worldwide, royalty-free license to host,
                            use, reproduce, adapt, publish, translate, and distribute that content in connection with
                            operating and promoting the Service. This license ends with respect to content you delete or
                            that is removed when you deactivate your account, except where copies have already been
                            shared with others as part of using the Service and reasonably remain in their view.
                            <br />
                            This license is limited to the extent necessary to provide and promote the Service. You retain
                            ownership of your content.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">14. Content Moderation</h4>
                        <p className="mb-0">
                            We may remove, restrict, or modify content, and suspend or deactivate accounts, at any time
                            and for any reason permitted by law.
                            <br />
                            We may take these actions, including banning a user, without prior warning, explanation, or
                            appeal, at our sole discretion.
                            <br />
                            Content may be reviewed by staff and may be processed by third-party tools for spam
                            prevention, safety, or service operations.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">15. Termination</h4>
                        <p className="mb-0">
                            Wefayo may suspend or terminate your access to the Service at any time, with or without
                            notice, for any reason, including but not limited to violation of these Terms, conduct harmful to
                            other users or to Wefayo, or if we discontinue the Service.
                            <br />
                            Upon termination, your right to use the Service ceases immediately. Content you have posted
                            may remain on the Service at Wefayo's discretion, subject to our content and moderation
                            policies. Sections of these Terms that by their nature should survive termination including
                            Sections 4, 13, 16, 17, 18, and 19 will continue to apply.
                            <br />
                            To deactivate your own account, email support@wefayo.com with the subject line “Account
                            Deactivation.”
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">16. External Links</h4>
                        <p className="mb-0">
                            The Service may contain links to third-party websites or services. We are not responsible for
                            their content, availability, accuracy, or practices. Visiting external links is at your own risk.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">17. Copyright Complaints</h4>
                        <p className="mb-0">
                            Wefayo has designated an agent to receive notifications of claimed copyright infringement.
                            <br />
                            Designated Agent: Wefayo LLC, Attn: Copyright Agent, 60 June Road, Unit 593, North Salem,
                            NY 10560. Email: support@wefayo.com.
                            <br />
                            If you believe your copyrighted work has been posted on Wefayo without permission, please
                            notify our Designated Agent at support@wefayo.com with the subject line “Copyright
                            Infringement Notice.” Your notice should include:
                            <ul className="list-disc pl-5 mt-0 mb-0">
                                <li className="mb-0 mt-0">The title, creation date, and original publication location of the work</li>
                                <li className="mb-0 mt-0">A description of where the infringing material appears on the Service, including a link and
                                    screenshot</li>
                                <li className="mb-0 mt-0">Your contact information (name, email, address, phone)</li>
                                <li className="mb-0 mt-0">A statement that you have a good faith belief the use is unauthorized</li>
                                <li className="mb-0 mt-0">A statement, under penalty of perjury, that you are the copyright owner or authorized to
                                    act on their behalf</li>
                            </ul>
                            We may remove content or terminate repeat infringers, or users who submit false or bad-faith
                            notices.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">18. Disclaimer of Warranties</h4>
                        <p className="mb-0">
                            THE SERVICE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT
                            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
                            LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                            PARTICULAR PURPOSE, AND NONINFRINGEMENT.
                            <br />
                            WE DO NOT GUARANTEE THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-
                            FREE, SECURE, OR THAT ANY CONTENT ON THE SERVICE IS ACCURATE OR
                            RELIABLE. YOUR USE OF THE SERVICE IS ENTIRELY AT YOUR OWN RISK.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">19. Limitation of Liability</h4>
                        <p className="mb-0">
                            TO THE FULLEST EXTENT PERMITTED BY LAW, WEFAYO WILL NOT BE LIABLE FOR
                            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
                            DAMAGES ARISING FROM YOUR USE OF THE SERVICE, YOUR RELIANCE ON ANY CONTENT POSTED BY USERS OR VOLUNTEER CONTRIBUTORS, OR YOUR USE OF
                            ANY AI OUTPUT.
                            <br />
                            THIS LIMITATION APPLIES EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF
                            SUCH DAMAGES.
                        </p>
                    </div>


                    <div>
                        <h4 className="mt-0">20. Indemnification</h4>
                        <p className="mb-0">
                            You agree to defend, indemnify, and hold harmless Wefayo and its officers, directors,
                            employees, and agents from claims, demands, losses, liabilities, damages, and expenses,
                            including reasonable attorneys' fees, arising from your use of the Service, your content, or your
                            violation of these Terms.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">21. Dispute Resolution</h4>
                        <p className="mb-0">
                            Before bringing a legal claim against Wefayo, you agree to first notify us in writing at
                            support@wefayo.com and allow 90 days to attempt informal resolution. Please describe your
                            claim in reasonable detail so we can respond meaningfully.
                            <br />
                            If the dispute cannot be resolved informally, you agree that any legal action shall be brought
                            exclusively in the state or federal courts located in Delaware, and you consent to the personal
                            jurisdiction of those courts.
                            <br />
                            These Terms are governed by the laws of the State of Delaware, without regard to its conflict of
                            law provisions. Any claim must be filed within one year of the event giving rise to the claim, to
                            the extent permitted by law.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">22. Assignment and Business Transfers</h4>
                        <p className="mb-0">
                            If Wefayo is acquired by, merges with, or sells substantially all of its assets to another company,
                            these Terms may be assigned to that successor as part of the transaction. Any successor will
                            remain bound by these Terms, unless you are given notice of materially different terms.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">23. Severability</h4>
                        <p className="mb-0">
                            If any provision of these Terms is found to be unenforceable or invalid by a court of competent
                            jurisdiction, that provision will be limited or eliminated to the minimum extent necessary, and the
                            remaining provisions of these Terms will continue in full force and effect.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">24. Privacy</h4>
                        <p className="mb-0">
                            Your use of the Service is also governed by our Privacy Policy, which is incorporated into these
                            Terms by reference. Please review our Privacy Policy to understand our practices. By using the
                            Service, you agree to the collection and use of information as described in the Privacy Policy.
                        </p>
                    </div>

                    <div>
                        <h4 className="mt-0">25. Contact Us</h4>
                        <p  className="mb-0">
                            If you have questions about these Terms, contact us at <a href="mailto:support@wefayo.com">support@wefayo.com</a>.
                        </p>
                    </div>

                     

                </div>

            </article>
        </CommunityLayout>
    );
};

export default TermsOfUse;

